import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M31.857 18.365 15.683 34.54a1.571 1.571 0 1 1-2.223-2.223l16.175-16.174H14.57a1.571 1.571 0 0 1 0-3.143h18.862a1.567 1.567 0 0 1 1.103.457l.007.007c.282.284.457.675.457 1.107V33.43a1.571 1.571 0 0 1-3.143 0V18.365Z"
    }
  )
);
var SvgOutboundOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var OutboundOutlined_default = SvgOutboundOutlined;

export { OutboundOutlined_default as default };
